import { DefaultUrlSerializer, UrlTree } from "@angular/router";
import { FeaturePath } from "@shared/enum/featurePath.enum";

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const urlLowerCase = url?.toLowerCase();
    if (urlLowerCase?.includes(FeaturePath.RSA_VB_WEBCHAT)) {
      return super.parse(urlLowerCase);
    }
    return super.parse(url);
  }
}